window.theme = window.theme || {}
theme.utilites = (function () {
	const utilitiesBind = () => {
		ScrollReveal().reveal(".scrollreveal", { delay: 200 })

		// Scroll to product on collections pages
		if (!window.location.pathname.includes("collections") && !window.location.pathname.includes("products")) {
			const productID = localStorage.getItem("productID")
			if (productID) {
				console.log(`Removed ${productID} from local storage!`)
				localStorage.removeItem("productID")
			}
		}
		$(".product-item").click(function () {
			console.log(`Added ${$(this).parent().attr("id")} to local storage!`)
			localStorage.setItem("productID", $(this).parent().attr("id"))
		})
		$(".headerNav a").click(function () {
			localStorage.removeItem("productID")
		})
		// Scroll to product on collections pages //

		// Masonry - articles, pages
		if ($(".masonry-items").length > 0) {
			const $grid = $(".masonry-items").imagesLoaded(function () {
				$grid.masonry({
					itemSelector: ".masonry-item",
					columnWidth: ".masonry-sizer",
					gutter: 0,
					percentPosition: true,
				})
			})
		}
		// Masonry - articles, pages //

		// Captcha button
		if ($(".shopify-challenge__button")) {
			$(this).addClass("btn-primary")
			$(".shopify-challenge__button").addClass("btn-primary").css("border", "none")
		}

		// Footer anchor scroll
		$('.footerNav a[href*="#"]').click(function (e) {
			e.preventDefault()
			const anchor = $(this).attr("href")
			console.log(anchor)
			if (location.pathname == "/") {
				if (anchor.length > 0) {
					const scrollTo = $(anchor).offset().top - 30
					$("body,html").animate({ scrollTop: scrollTo }, 1500)
				}
			} else {
				if (anchor.length > 0) {
					window.location = `/${anchor}`
				}
			}
		})

		// index-booking popup
		$("[data-booking-popup]").click(function (e) {
			e.preventDefault()
			const $popup = $($(this).data("booking-popup"))

			let state = $popup.hasClass("show-popup")
			if (state) {
				$popup.fadeOut(50, function () {
					$popup.removeClass("show-popup")
					$("body").css("overflow", "auto")
				})
			} else {
				$popup.fadeIn(50, function () {
					$popup.addClass("show-popup")
					$("body").css("overflow", "hidden")
				})
			}
		})

		// careers-and-opportunities page
		$(".accordion-item-2 .accordion-item__header").on("click", function (e) {
			e.preventDefault()
			$(this).next().fadeToggle()
		})

		// header menu desktop & mobile
		$("[data-more-details]").click(function () {
			$(this).toggleClass("open")
			let $that = $(this)
			if ($(this).hasClass("open")) {
				$(".description .less").slideUp(function () {
					$(".description .more").slideDown()
					$($that).text("Less information")
				})
			} else {
				$(".description .more").slideUp(function () {
					$(".description .less").slideDown()
					$($that).text("More information")
				})
			}
		})
		$(".headerIcons .search").click(function (e) {
			e.preventDefault()
			$(this).parent().find(".searchinput").toggleClass("active").find("input").focus()
		})
		$(".btn-menu").hover(function () {
			const header = $(".header")
			const mainNav = $("#main-nav")
			const headerLogo = $(".header .headerLogo")
			const fullNav = $("#full-nav")

			// Activate desktop menu
			header.addClass("invert")
			headerLogo.find(".black").addClass("hide")
			headerLogo.find(".white").removeClass("hide")
			fullNav.removeClass("hide")

			fullNav.mouseleave(function () {
				turnOff()
			})
			mainNav.click(function () {
				turnOff()
			})
			// Disable desktop menu
			function turnOff() {
				fullNav.addClass("hide")
				header.removeClass("invert")
				headerLogo.find(".black").removeClass("hide")
				headerLogo.find(".white").addClass("hide")
			}
		})

		// Handler for display mobile menu
		$(".btn.btn-mobile-menu").on("click", function () {
			$(this).find("#open-icon").toggleClass("hide")
			$(this).find("#close-icon").toggleClass("hide")
			$(".header #mobile-nav").toggleClass("hide")
			$(".header").toggleClass("mobile-active")
		})

		// Handler for desktop and mobile menu (childs)
		$(".menu-parent").on("click", function (e) {
			e.preventDefault()
			const $nextChild = $($(this).parent().next(".menu-child"))
			if ($nextChild.hasClass("active-child")) {
				$nextChild.slideUp(function () {
					$nextChild.removeClass("active-child")
					console.log("Navigation menu child has been closed")
				})
			} else {
				$nextChild.slideDown(function () {
					$nextChild.addClass("active-child")
					console.log("Navigation child menu has been opened")
				})
			}
		})

		$("#mobile-nav .menu-link.menu-parent").click(function (e) {
			e.preventDefault()
			$(this).next(".menu-bigchild").addClass("active-child")
			console.log("Mobile navigation menu bigchild has been opened")
		})
		$("#mobile-nav .btn.btn-mobile-menu-back").on("click", function (e) {
			e.preventDefault()
			$(this).parent(".menu-bigchild").removeClass("active-child")
			console.log("Mobile navigation menu bigchild has been closed")
		})

		// Blog Events Select
		$(".block-events-list .title").click(function () {
			const $inner = $($(this).siblings(".inner"))
			let isOpen = $inner.hasClass("active")
			if (isOpen) {
				$inner.removeClass("active")
			} else {
				$inner.addClass("active")
			}
		})
		// Collection filter
		$("[data-collection-filter").click(function () {
			const $currentFilter = $($(this).data("collection-filter"))
			let $currentFilterState = $currentFilter.hasClass("close-filter")
			if ($currentFilterState) {
				$currentFilter.removeClass("close-filter")
				$("body").addClass("collection-filter-overflow")
				console.log("Filter has been opened.")
			} else {
				$currentFilter.addClass("close-filter")
				$("body").removeClass("collection-filter-overflow")
				console.log("Filter has been closed.")
			}
		})
		// Customer Pages
		$(".addresses-switch").click(function (e) {
			e.preventDefault()
			let isActive = $(".form-customer-new-addresses").hasClass("switch-active")

			if (isActive) {
				$(".form-customer-addresses").css("display", "flex")
				$(".form-customer-new-addresses").css("display", "none")
				$(".form-customer-new-addresses").removeClass("switch-active")
			} else {
				$(".form-customer-addresses").css("display", "none")
				$(".form-customer-new-addresses").css("display", "flex")
				$(".form-customer-new-addresses").addClass("switch-active")
			}
		})
		$(".login-switch").click(function (e) {
			e.preventDefault()
			let isActive = $(".form-customer-recover").hasClass("switch-active")

			if (isActive) {
				$(".form-customer-login").css("display", "block")
				$(".form-customer-recover").css("display", "none")
				$(".form-customer-recover").removeClass("switch-active")
			} else {
				$(".form-customer-login").css("display", "none")
				$(".form-customer-recover").css("display", "block")
				$(".form-customer-recover").addClass("switch-active")
			}
		})
		// product-item swatch (snippet)
		$(".product-item .product-content .image").mouseenter(function () {
			$(this).parent().parent().siblings(".product-item-hover").fadeIn()
		})
		$(".product-item .product-item-hover").mouseleave(function () {
			$(this).fadeOut()
		})
		$(".btn-variant.open").click(function () {
			const $swatch = $($(this).parent().parent().siblings(".product-swatch"))
			if ($swatch.hasClass("swatch-open")) {
				$swatch.fadeOut(function () {
					$swatch.removeClass("swatch-open")
				})
			} else {
				$swatch.fadeIn(function () {
					$swatch.addClass("swatch-open")
				})
			}
		})
		$(".btn-variant.close").click(function () {
			const $swatch = $($(this).parent().parent())
			if ($swatch.hasClass("swatch-open")) {
				$swatch.fadeOut(function () {
					$swatch.removeClass("swatch-open")
				})
			}
		})
	}
	const tabsBind = () => {
		$(".accordion-item .name").on("click", function (e) {
			e.preventDefault()
			$(this).toggleClass("active")
			$(this).siblings(".inner").toggleClass("active")
		})
		$(".select-global").on("click", function () {
			$(this).toggleClass("active")
		})
	}
	const counter = () => {
		if ($(".release-time")) {
			$(".release-time").each(function () {
				let release_date = new Date($(this).data("datetime"))
				let current_element = $(this)
				let timer = countdown(
					release_date,
					function (ts) {
						ts.days < 10 ? (ts.days = "0" + ts.days) : ""
						ts.hours < 10 ? (ts.hours = "0" + ts.hours) : ""
						ts.minutes < 10 ? (ts.minutes = "0" + ts.minutes) : ""
						ts.seconds < 10 ? (ts.seconds = "0" + ts.seconds) : ""

						$(current_element).find(".days span").text(ts.days)
						$(current_element).find(".hours span").text(ts.hours)
						$(current_element).find(".minutes span").text(ts.minutes)
						$(current_element).find(".seconds span").text(ts.seconds)
					},
					countdown.DAYS | countdown.HOURS | countdown.MINUTES | countdown.SECONDS,
				)
			})
		}

		if ($("[data-col-release-date]")) {
			$("[data-col-release-date]").each(function () {
				let release_date = new Date($(this).data("col-release-date"))
				let current_element = $(this)
				let timer = countdown(
					release_date,
					function (ts) {
						ts.days < 10 ? (ts.days = "0" + ts.days) : ""
						ts.hours < 10 ? (ts.hours = "0" + ts.hours) : ""
						ts.minutes < 10 ? (ts.minutes = "0" + ts.minutes) : ""
						ts.seconds < 10 ? (ts.seconds = "0" + ts.seconds) : ""

						$(current_element).find("span.days").text(ts.days)
						$(current_element).find("span.hours").text(ts.hours)
						$(current_element).find("span.minutes").text(ts.minutes)
						$(current_element).find("span.seconds").text(ts.seconds)
					},
					countdown.DAYS | countdown.HOURS | countdown.MINUTES | countdown.SECONDS,
				)
			})
		}

		if ($("[data-prod-release-date]")) {
			$("[data-prod-release-date]").each(function () {
				let release_date = new Date($(this).data("prod-release-date"))
				let current_element = $(this)
				let timer = countdown(
					release_date,
					function (ts) {
						ts.days < 10 ? (ts.days = "0" + ts.days) : ""
						ts.hours < 10 ? (ts.hours = "0" + ts.hours) : ""
						ts.minutes < 10 ? (ts.minutes = "0" + ts.minutes) : ""
						ts.seconds < 10 ? (ts.seconds = "0" + ts.seconds) : ""

						$(current_element).find("span.days").text(ts.days)
						$(current_element).find("span.hours").text(ts.hours)
						$(current_element).find("span.minutes").text(ts.minutes)
						$(current_element).find("span.seconds").text(ts.seconds)
					},
					countdown.DAYS | countdown.HOURS | countdown.MINUTES | countdown.SECONDS,
				)
			})
		}
	}

	const init = () => {
		counter()
		tabsBind()
		utilitiesBind()
	}
	return { init }
})($)

theme.carousels = (function () {
	const homepageCarousel = () => {
		const carousel = ".homepage-carousel.owl-carousel"
		const settings = {
			items: 1,
			dots: true,
			nav: false,
			rewind: true,
		}
		$(carousel).owlCarousel(settings)

		Shopify.designMode &&
			document.addEventListener("shopify:section:load", (event) => {
				if ($(event.target).hasClass("hero-slideshow")) {
					console.log("Homepage hero carousel has been reload!")

					$(carousel).trigger("destroy.owl.carousel")
					$(carousel).owlCarousel(settings)
				}
			})
	}
	const releaseCarousel = () => {
		const carousel = ".release-carousel.owl-carousel"
		const settings = {
			items: 1,
			dots: true,
			nav: false,
			rewind: true,
		}
		$(carousel).owlCarousel(settings)
		Shopify.designMode &&
			document.addEventListener("shopify:section:load", (event) => {
				if ($(event.target).hasClass("releases")) {
					console.log("Releases Carousel has been reload!")

					$(carousel).trigger("destroy.owl.carousel")
					$(carousel).owlCarousel(settings)
				}
			})
	}
	const imagesCarousel = () => {
		$(".images-carousel.owl-carousel").owlCarousel({
			loop: true,
			dots: true,
			nav: false,
			rewind: true,
			margin: 30,
			responsiveClass: true,
			responsive: {
				0: {
					items: 1,
				},
				440: {
					items: 2,
				},
				639: {
					items: 3,
				},
				1023: {
					items: 4,
				},
			},
		})
	}
	const productsCarousel = () => {
		$(".products-carousel.owl-carousel").owlCarousel({
			dots: true,
			nav: false,
			margin: 20,
			responsiveClass: true,
			responsive: {
				0: {
					items: 1,
				},
				440: {
					items: 2,
				},
				639: {
					items: 3,
				},
				1023: {
					items: 4,
				},
				1440: {
					items: 4,
				},
				1600: {
					items: 5,
				},
			},
			// autoplay: true
		})
	}
	const blogCarousel = () => {
		$(".blog-carousel.owl-carousel").owlCarousel({
			items: 1,
			loop: true,
			dots: true,
			nav: false,
			rewind: true,
			margin: 20,
			// autoplay: true
		})
	}
	const mobileNavCarousel = () => {
		$(".mobile-nav-carousel.owl-carousel").owlCarousel({
			items: 1,
			dots: false,
			nav: false,
			rewind: true,
			margin: 16,
			responsiveClass: true,
			responsive: {
				0: {
					items: 1,
				},
				440: {
					items: 2,
				},
				640: {
					items: 3,
				},
			},
			// autoplay: true
		})
	}
	const eatsCarousel = () => {
		$(".eats-carousel.owl-carousel").owlCarousel({
			items: 1,
			loop: false,
			dots: true,
			nav: false,
			rewind: true,
			margin: 30,
			// autoplay: true
		})
	}
	const editorialCarousel = () => {
		$(".editorial-carousel.owl-carousel").owlCarousel({
			items: 1,
			loop: true,
			dots: true,
			nav: false,
			rewind: true,
			margin: 10,
			// autoplay: true
		})
	}

	const articlesAndPagesCarousel = () => {
		$(".slider-images.owl-carousel").owlCarousel({
			items: 1,
			loop: true,
			dots: true,
			nav: false,
			rewind: true,
			margin: 10,
		})
	}

	const productsListSliderCarousel = () => {
		$(".products-list-slider-carousel").owlCarousel({
			loop: true,
			dots: true,
			nav: false,
			rewind: true,
			responsiveClass: true,
			responsive: {
				0: {
					items: 1,
				},
				440: {
					items: 2,
				},
				639: {
					items: 3,
				},
				1023: {
					items: 4,
				},
			},
			onInitialized: function (event) {
				const target = event.target.id ? event.target.id : event.target.classList[1]
				console.log(`${target} has been initialized.`)
			},
		})
	}

	const articleFitGuideCarousel = () => {
		const carousel = ".fit-guide-carousel.owl-carousel"
		const settings = {
			items: 1,
			loop: true,
			dots: false,
			nav: true,
			rewind: true,
			autoHeight: true,
			responsiveClass: true,
			responsive: {
				0: {
					stagePadding: 0,
				},
				1023: {
					stagePadding: 0,
				},
				1440: {
					stagePadding: 0,
				},
				1600: {
					stagePadding: 0,
				},
			},
			navText: ["", "<span></span>"],
		}
		$(carousel).owlCarousel(settings)

		Shopify.designMode &&
			document.addEventListener("shopify:section:load", (event) => {
				if ($(event.target).hasClass("article-fit-guide")) {
					console.log("Article Fit Guide carousel has been reload!")

					$(carousel).trigger("destroy.owl.carousel")
					$(carousel).owlCarousel(settings)
				}
			})
	}

	const init = () => {
		homepageCarousel()
		releaseCarousel()
		productsCarousel()
		blogCarousel()
		imagesCarousel()
		mobileNavCarousel()
		eatsCarousel()
		editorialCarousel()
		articlesAndPagesCarousel()
		productsListSliderCarousel()
		articleFitGuideCarousel()
	}
	return { init }
})($)

theme.cart = (function () {
	let itemsCount = 0
	const init = () => {
		window.location.pathname.includes("/cart") ? renderRegularCart() : console.log(window.location.pathname);
		$(".cart-icon").click(function () {
			if ($(".cart-box").hasClass("active")) {
				theme.cart.closeCart()
			} else {
				theme.cart.openCart()
			}
		})
		$(document).on("click", function (e) {
			if ($(e.target).closest(".cart-icon").length <= 0) {
				if ($(e.target).closest(".cart-box").length || !$(".cart-box").hasClass("active")) return
				theme.cart.closeCart()
			}
		})
		// main-product.liquid
		$(".product-ajax-form").submit(function (e) {
			e.preventDefault()
			addToCart_form($(this))
		})
		$(".product-ajax-form input").on("change", function () {
			const $this = $(this)

			$this.parents(".product-ajax-form").find('input[name="id"]').val($this.val())
			console.log("Selected variant - ", $this.val())

			if ($this.data("variant-size-guide")) {
				console.log($this.data("variant-size-guide"))
				$(".size-guide a").addClass("hide")
				$(`.${$this.data("variant-size-guide")}`).removeClass("hide")
			} else {
				$(".size-guide a").addClass("hide")
			}
		})
		// product-swatch
		$(".product-ajax-form .swatch-submit").click(function (e) {
			e.preventDefault()
			$(this).parents(".product-ajax-form").find('input[name="id"]').val($(this).prev("input").val())
			console.log("Selected variant - ", $(this).prev("input").val())
			addToCart_form($(this).parents(".product-ajax-form"))
		})
		// main-article-fit-guide.liquid
		const guideSelect = document.querySelector("#fit-guide-select")
		if (guideSelect) {
			NiceSelect.bind(guideSelect)
		}
		$("#fit-guide-select").on("change", function (e) {
			e.preventDefault()
			$(".fit-guide-popup .fit-guide").addClass("hide")
			$(`.fit-guide-popup .fit-guide.${$(this).val()}`).removeClass("hide")
		})
		$(".btn-fit-guide").on("click", function (e) {
			e.preventDefault()
			if ($(".fit-guide-popup").hasClass("hide")) {
				$(".fit-guide-popup").removeClass("hide")
			} else {
				$(".fit-guide-popup").addClass("hide")
			}
		})
	}
	const openCart = async () => {
		$(".cart-box").addClass("active").fadeIn(100)
		$(".cart-box .content-loader").html(`<div class="ring-loader"><div></div><div></div><div></div><div></div></div>`)
		$(".cart-box .content-loader").load(
			"/cart?view=ajax",
			await function () {
				let cartJson = JSON.parse($(".content-loader").find("#cartJSON").text())
				itemsCount = cartJson.item_count
				$(".cart-icon p").text(itemsCount)
				$(".cart-ajax-delete").click(function (e) {
					e.preventDefault()
					updateQuantity($(this).val(), $(this).data("key"))
				})

				$(".cart-box .quantity input").change(function () {
					updateQuantity($(this).val(), $(this).data("key"))
				})
				$(".cart-box .quantity").click(function () {
					updateQuantity($(this).find("input").val(), $(this).find("input").data("key"))
				})
				$(".cart-box .quantity .minus").click(function () {
					if ($(this).next("input").val() <= 0) return false
					$(this)
						.next("input")
						.val(+$(this).next("input").val() - 1)
				})
				$(".cart-box .quantity .plus").click(function () {
					$(this)
						.prev("input")
						.val(+$(this).prev("input").val() + 1)
				})

				if(typeof affirm !== 'undefined') {
					affirm.ui.ready(function () {
						affirm.ui.refresh()
						console.log("affirm refreshed")
					})
				}
			},
		)
	}

	const renderRegularCart = async () => {
		$(".main-cart .content-loader").html(`<div class="ring-loader"><div></div><div></div><div></div><div></div></div>`)
		$(".main-cart .content-loader").load(
			"/cart?view=ajax",
			await function () {
				let cartJson = JSON.parse($(".content-loader").find("#cartJSON").text())
				itemsCount = cartJson.item_count
				$(".cart-icon p").text(itemsCount)
				$(".cart-ajax-delete").click(function (e) {
					e.preventDefault()
					updateQuantity($(this).val(), $(this).data("key"))
				})

				$(".main-cart .quantity input").change(function () {
					updateQuantity($(this).val(), $(this).data("key"))
				})
				$(".main-cart .quantity").click(function () {
					updateQuantity($(this).find("input").val(), $(this).find("input").data("key"))
				})
				$(".main-cart .quantity .minus").click(function () {
					if ($(this).next("input").val() <= 0) return false
					$(this)
						.next("input")
						.val(+$(this).next("input").val() - 1)
				})
				$(".main-cart .quantity .plus").click(function () {
					$(this)
						.prev("input")
						.val(+$(this).prev("input").val() + 1)
				})
				
				if(typeof affirm !== 'undefined') {
					affirm.ui.ready(function () {
						affirm.ui.refresh()
						console.log("affirm refreshed")
					})
				}
			},
		)
	}
	const closeCart = () => {
		$(".cart-box").removeClass("active").fadeOut(100)
	}
	function reloadCart() {
		$(".cart-box .content-loader").html(`<div class="ring-loader"><div></div><div></div><div></div><div></div></div>`)
		$(".cart-box .content-loader").load("/cart?view=ajax", function () {
			let cartJson = JSON.parse($(".content-loader").find("#cartJSON").text())
			itemsCount = cartJson.item_count
			$(".cart-icon p").text(itemsCount)
			// $(".remove-button").click(function () {
			// 	theme.cart.updateQuantity(0, $(this).data("key"));
			// });
		})
	}	
	function addToCart_form($form) {
		$.ajax({
			url: "/cart/add.js",
			type: "POST",
			data: $form.serialize(),
			dataType: "json",
			contentType: "application/x-www-form-urlencoded",
			success: function () {
				console.log("Successed added!")
				theme.cart.openCart()
				nativeToast({
					message: "Added!",
					timeout: 5000,
					rounded: true,
					position: "south",
					closeOnClick: true,
					type: "success",
				})
			},
			error: function (e) {
				console.error(e.responseJSON.description.toUpperCase())
				if (e.status == 422) {
					nativeToast({
						message: "Out Of Stock!",
						timeout: 5000,
						rounded: true,
						position: "east",
						closeOnClick: true,
						type: "error",
					})
				} 
                else if (e.responseJSON.description.toUpperCase() === "REQUIRED PARAMETER MISSING OR INVALID: ID") {
					nativeToast({
						message: "Please select a size",
						timeout: 5000,
						rounded: true,
						position: "east",
						closeOnClick: true,
						type: "error",
					})
				}
				else {
					nativeToast({
						message: e.responseJSON.description.toUpperCase(),
						timeout: 5000,
						rounded: true,
						position: "east",
						closeOnClick: true,
						type: "error",
					})
				}
			},
		})
	}
	function addToCart(variant, quantity) {
		$.ajax({
			url: "/cart/add.js",
			type: "POST",
			data: JSON.stringify({ quantity: quantity, id: variant }),
			dataType: "json",
			contentType: "application/json",
			success: function () {
				$("#ajax-cart .cart-body .ajax-container")
					.fadeOut()
					.html(
						`
          <div class="loader">
            <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
          </div>`,
					)
					.fadeIn()
				openCart()
				nativeToast({
					message: "Added!",
					timeout: 5000,
					rounded: true,
					position: "south",
					closeOnClick: true,
					type: "success",
				})
			},
			error: function (e) {
				let error = JSON.parse(e.responseText)
				console.log(error)
				if (error.status == 422) {
					nativeToast({
						message: "Out Of Stock!",
						timeout: 5000,
						rounded: true,
						position: "south",
						closeOnClick: true,
						type: "error",
					})
				}
			},
		})
	}
	function updateQuantity(quantity, key) {
		$.ajax({
			url: "/cart/change.js",
			type: "POST",
			data: JSON.stringify({ quantity: quantity, id: key }),
			dataType: "json",
			contentType: "application/json",
			success: function (data) {
				console.log("Successed updated!")
				if (quantity > 0) {
					let item_quantity = data.items.filter((i) => i.key == key)[0].quantity
					if (quantity != item_quantity) {
						nativeToast({
							message: "Out Of Stock!",
							timeout: 5000,
							rounded: true,
							position: "south",
							closeOnClick: true,
							type: "error",
						})
						$(`[data-key="${key}"]`).val(item_quantity)
					} else {
						nativeToast({
							message: "Quantity changed",
							timeout: 5000,
							rounded: true,
							position: "south",
							closeOnClick: true,
							type: "success",
						})
						window.location.pathname.includes("/cart") ? theme.cart.renderRegularCart() : theme.cart.openCart()
					}
				} else {
					nativeToast({
						message: "Removed",
						timeout: 5000,
						rounded: true,
						position: "south",
						closeOnClick: true,
						type: "success",
					})
					window.location.pathname.includes("/cart") ? theme.cart.renderRegularCart() : theme.cart.openCart()
				}
			},
			error: function (e) {
				console.error(e.responseJSON.description.toUpperCase())
				if (e.status == 422) {
					nativeToast({
						message: "Out Of Stock!",
						timeout: 5000,
						rounded: true,
						position: "south",
						closeOnClick: true,
						type: "error",
					})
				}
			},
		})
	}
	return {
		init,
		openCart,
		renderRegularCart,
		closeCart,
		itemsCount,
		updateQuantity,
		addToCart_form,
	}
})($)

theme.ProductRecommendations = (function () {
	function ProductRecommendations() {
		const $container = $(".product-recommendations")
		if ($container.length > 0) {
			const baseUrl = $container.data("baseUrl")
			const productId = $container.data("productId")
			const limit = $container.data("limit")
			const sectionId = $container.parent().attr("id").split("shopify-section-")[1]
			const productRecommendationsUrlAndContainerClass = baseUrl + "?section_id=" + sectionId + "&limit=" + limit + "&product_id=" + productId
			$container.parent().load(productRecommendationsUrlAndContainerClass, function () {
				// product-item swatch (snippet)
				$(".product-item .product-content .image").mouseenter(function () {
					$(this).parent().parent().siblings(".product-item-hover").fadeIn()
				})
				$(".product-item .product-item-hover").mouseleave(function () {
					$(this).fadeOut()
				})
				$(".btn-variant.open").click(function () {
					const $swatch = $($(this).parent().parent().siblings(".product-swatch"))
					if ($swatch.hasClass("swatch-open")) {
						$swatch.fadeOut(function () {
							$swatch.removeClass("swatch-open")
						})
					} else {
						$swatch.fadeIn(function () {
							$swatch.addClass("swatch-open")
						})
					}
				})
				$(".btn-variant.close").click(function () {
					const $swatch = $($(this).parent().parent())
					if ($swatch.hasClass("swatch-open")) {
						$swatch.fadeOut(function () {
							$swatch.removeClass("swatch-open")
						})
					}
				})
				$(".product-ajax-form .swatch-submit").click(function (e) {
					e.preventDefault()
					$(this).parents(".product-ajax-form").find('input[name="id"]').val($(this).prev("input").val())
					console.log("Selected variant - ", $(this).prev("input").val())
					theme.cart.addToCart_form($(this).parents(".product-ajax-form"))
				})
			})
		}
	}
	return ProductRecommendations
})()

theme.init = function () {
	theme.cart.init()
	theme.carousels.init()
	theme.utilites.init()
	theme.ProductRecommendations()
}
$(function () {
	theme.init($)
})

$(window).on("load", function () {
	$(".preloader").fadeOut(2)
	$("body").attr("id", "")

	// Scroll to product on collections pages
	if (window.location.pathname.includes("collections") && !window.location.pathname.includes("products")) {
		const productID = localStorage.getItem("productID")
		if (productID) {
			console.log("Product ID from local storage -", productID)
			if (productID.length > 0) {
				const productAnchor = "#" + productID
				if ($(".boost-pfs-filter-products").find(productAnchor).length > 0) {
					console.log(`Product with anchor ${productAnchor} finded`, $(".boost-pfs-filter-products").find(productAnchor))
					const scrollTo = $(productAnchor).offset().top - 30
					$("body,html").animate({ scrollTop: scrollTo }, 1500)
				}
			}
		}
	}
	// Scroll to product on collections pages //
})
